import * as React from "react";

export interface VeboxExpandableProps {
    collapsed: JSX.Element | string | ((state: boolean, setState: (newState: boolean) => void) => JSX.Element | string);
    defaultExpanded?: boolean;
    expanded?: boolean;
}

export const VeboxExpandable: React.FC<VeboxExpandableProps> = (props) => {

    const [expanded, setExpanded] = React.useState<boolean>(props.defaultExpanded ?? false);

    React.useEffect(() => {
        setExpanded(props.expanded);
    }, [props.expanded])

    return (
        <>
            {typeof props.collapsed === 'function'
                ? props.collapsed(expanded, setExpanded)
                : props.collapsed
            }
            {
                expanded
                    ? props.children
                    : undefined
            }
        </>
    );
}